import { classNames } from "@indietabletop/appkit/class-names";
import { atomic } from "../atomic.css";

export function Paragraphs(props: { text: string; className?: string }) {
  return (
    <div
      className={classNames(
        props.className,
        atomic({ display: "flex", gap: 12, flexDirection: "column" }),
      )}
    >
      {props.text.split(/\n+/).map((line, index) => {
        return (
          <p key={index} className={atomic({ lineHeight: 1.5 })}>
            {line}
          </p>
        );
      })}
    </div>
  );
}
